import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { formatExportCell } from "./exportReportPdfFromExcelBlob";

/**
 * Build A4 landscape PDF from Pallet Storage Visibility Excel export.
 * Reuses the same grouped header structure as the Excel file (CASES / PALLETS).
 */
export async function exportPalletStorageReportPdfFromExcelBlob(
  excelBlob,
  filename
) {
  const data = await excelBlob.arrayBuffer();
  const workbook = XLSX.read(data, { type: "array", cellDates: true });
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) {
    throw new Error("Export file has no worksheet");
  }

  const worksheet = workbook.Sheets[sheetName];
  const rows = XLSX.utils.sheet_to_json(worksheet, {
    header: 1,
    defval: "",
    raw: false,
  });

  const groupRow = Array.isArray(rows[0]) ? rows[0] : [];
  const headerRow = Array.isArray(rows[1]) ? rows[1] : [];
  const bodyRows = rows.slice(2);

  const casesIndex = groupRow.findIndex(
    (cell) => String(cell).trim().toUpperCase() === "CASES"
  );
  const palletsIndex = groupRow.findIndex(
    (cell) => String(cell).trim().toUpperCase() === "PALLETS"
  );

  const baseCount = casesIndex >= 0 ? casesIndex : 9;
  const casesCount =
    casesIndex >= 0 && palletsIndex > casesIndex ? palletsIndex - casesIndex : 5;
  const palletsCount = Math.max(0, headerRow.length - baseCount - casesCount);

  const baseHeaders = headerRow.slice(0, baseCount).map((cell) => String(cell ?? ""));
  const movementHeaders = headerRow
    .slice(baseCount)
    .map((cell) => String(cell ?? ""));

  const topHeadRow = [
    ...baseHeaders.map((label) => ({ content: label, rowSpan: 2 })),
    {
      content: "CASES",
      colSpan: casesCount,
      styles: { halign: "center" },
    },
    {
      content: "PALLETS",
      colSpan: palletsCount,
      styles: { halign: "center" },
    },
  ];

  const body = bodyRows.map((row) => {
    const cells = Array.isArray(row) ? row : [];
    return headerRow.map((_, colIndex) =>
      formatExportCell(cells[colIndex] ?? "")
    );
  });

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: "a4",
  });

  autoTable(doc, {
    head: [topHeadRow, movementHeaders],
    body,
    styles: {
      fontSize: 5,
      cellPadding: 1.5,
      overflow: "linebreak",
      lineWidth: 0.25,
      lineColor: [180, 180, 180],
    },
    headStyles: {
      fillColor: [245, 245, 245],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      fontSize: 5.5,
    },
    showHead: "everyPage",
    margin: { top: 28, left: 12, right: 12, bottom: 28 },
    rowPageBreak: "avoid",
  });

  doc.save(filename);
}
